package com.gastoncantera.intercom.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gastoncantera.intercom.push.MissedCall

@Composable
fun MissedCallsDialog(calls: List<MissedCall>, onDismiss: () -> Unit) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Text(if (calls.size == 1) "Llamada perdida" else "Llamadas perdidas (${calls.size})")
        },
        text = {
            Column {
                calls.forEach { call ->
                    Column(modifier = Modifier.padding(vertical = 4.dp)) {
                        Text(
                            text = buildString {
                                append("• ${call.title}")
                                if (call.subtitle.isNotEmpty()) append(" — ${call.subtitle}")
                            },
                            style = MaterialTheme.typography.bodyMedium,
                        )
                        Text(
                            text = call.timeLabel,
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    }
                }
            }
        },
        confirmButton = {
            TextButton(onClick = onDismiss) { Text("Entendido") }
        },
    )
}
